import { Button, CenterSpinner } from '@mr-yum/frontend-ui'
import { CartLayout } from 'components/Cart/CartLayout'
import { CartLayoutBody, CartLayoutFooter } from 'components/Cart/shared'
import React from 'react'

interface Props {
  title?: string
  showBack?: boolean
}

export const ConfirmationLoader = ({ title, showBack = false }: Props) => (
  <CartLayout title={title} showBack={showBack}>
    <CartLayoutBody>
      <div className="mt-12">
        <CenterSpinner />
      </div>
    </CartLayoutBody>

    <CartLayoutFooter sticky>
      <Button type="button" variant="outline" size="lg" isLoading fullWidth>
        Back home
      </Button>
    </CartLayoutFooter>
  </CartLayout>
)
